import { SideSheetRoot } from "./SideSheet";
import { SideSheetHeader } from "./SideSheetHeader";
import { SideSheetBody } from "./SideSheetBody";
import { SideSheetFooter } from "./SideSheetFooter";

export const SideSheet = Object.assign(SideSheetRoot, {
  Header: SideSheetHeader,
  Body: SideSheetBody,
  Footer: SideSheetFooter,
});

export {
  SideSheetStackProvider,
  useSideSheetRegistration,
} from "./SideSheetContext";
export type {
  SideSheetProps,
  SideSheetHeaderProps,
  SideSheetBodyProps,
  SideSheetFooterProps,
  SideSheetStackStore,
} from "./types";
